import { component } from "picoapp";
import "slick-carousel";
import $ from "jquery";

export default component((node) => {
  $(window).bind("load resize", () => {
    const width = $(window).width();
    if (width <= 576) {
      $(node).find(".column-slider").not(".slick-initialized").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        dots: true,
      });
    } else {
      $(node).find(".column-slider.slick-initialized").slick("unslick");
    }
  });
});
